import React from 'react';

interface SVGExternalLinkProps {
  width?: string;
  height?: string;
  color?: string;
  strokeWidth?: string;
}

const SVGExternalLink = ({
  width = '24',
  height = '24',
  color = '#000',
  strokeWidth = '2',
}: SVGExternalLinkProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.5">
      <path
        d="M20 14.6V17.8667C20 18.4325 19.7752 18.9751 19.3752 19.3752C18.9751 19.7752 18.4325 20 17.8667 20H6.13333C5.56754 20 5.02492 19.7752 4.62484 19.3752C4.22476 18.9751 4 18.4325 4 17.8667V6.13333C4 5.56754 4.22476 5.02492 4.62484 4.62484C5.02492 4.22476 5.56754 4 6.13333 4H9.4"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 4H20V10"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13L20 4"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SVGExternalLink;
